// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'dev',
  production: false,
  apiUrl: 'http://10.10.3.249:8088',
  // apiUrl: 'http://10.10.3.249:8088/HRMS_Recruitment_Service/',
  navApiUrl: 'https://iffcotokio.co.in',
  contextPath: '',
  logInfoEnabled: true,
  logDebugEnabled: true,
  logWarnEnabled: true,
  logErrorEnabled: true,
  authToken: `Basic c3VwZXJ1c2VyOkl0Z2lAMTIz`,
  parentAppBaseUrl: 'https://www.iffcotokio.co.in',
  secret_key: 'iffco-tokio',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
